import React from 'react';

import { Theme } from 'ui_system/theme';
import ContentLoader from 'ui_system/utilities/ContentLoader';
import defaultImage from 'views/anyguide/tours/item/images/default_image.png';
import CustomTourImage from 'views/anyguide/bookings/tour_picture/custom_tour_default.jpg';

import { convertDateTimezone } from 'ui_system/utilities/timezoneUtils';
import {
  Row,
  Text,
  NameSection,
  PictureSection,
  LocationSection,
  DateSection,
  GuestsSection,
  ArrowSection,
  Image,
  LocationIcon,
  ComputerIcon,
} from '../styles';

const SlotRow = ({
  resourceTimezone,
  date,
  time,
  tour,
  placesConfirmed,
  placesConfirmedNoun,
  isCustomTour,
}) => {
  // Convert dateTime for resource (if online experience) + parse into moment object
  const dateTime = convertDateTimezone({
    originalTimezone: tour.timeZone,
    timezone: tour.isOnline ? resourceTimezone : tour.timeZone,
    date,
    dateFormat: 'YYYY-MM-DD',
    time,
    timeFormat: 'h:mma',
  });

  return (
    <Row>
      <DateSection gridArea="date">
        <Text hover bold fontSize={22}>
          {dateTime.format('D')}
        </Text>
        <Text hover>{dateTime.format('MMM')}</Text>
        <Text hover>{dateTime.format('h:mm A')}</Text>
      </DateSection>
      <PictureSection gridArea="picture">
        <Image
          src={[isCustomTour ? CustomTourImage : tour.picture]}
          loader={<ContentLoader height="100%" width="100%" />}
          unloader={<Image src={defaultImage} />}
        />
      </PictureSection>
      <NameSection gridArea="name">
        <Text hover mobileFontsize={13}>
          {tour.name}
        </Text>
        <br />
        <LocationSection>
          {(tour.shoppingCenter || tour.placesAddress) && !tour.isOnline && (
            <LocationIcon />
          )}
          {(tour.shoppingCenter || tour.placesAddress) && !tour.isOnline && (
            <Text
              hover
              color={Theme.colors.lightText}
              fontSize={12}
              marginLeft={16}
              mobileFontsize={11}
            >
              {tour.shoppingCenter}
              {tour.shoppingCenter && tour.placesAddress ? ', ' : ''}{' '}
              {tour.placesAddress}
            </Text>
          )}
          {tour.isOnline && <ComputerIcon />}
          {tour.isOnline && (
            <Text
              hover
              color={Theme.colors.lightText}
              fontSize={12}
              marginLeft={20}
              mobileFontsize={11}
            >
              Online
            </Text>
          )}
        </LocationSection>
        <GuestsSection hideDesktop gridArea="guests">
          <i className="af-people" />{' '}
          <Text hover bold marginRight={5} marginLeft={5} mobileFontsize={13}>
            {placesConfirmed}
          </Text>
          {placesConfirmedNoun}
        </GuestsSection>
      </NameSection>
      <GuestsSection hideMobile gridArea="guests">
        <i className="af-people" />{' '}
        <Text hover bold marginRight={5} marginLeft={5}>
          {placesConfirmed}
        </Text>
        {placesConfirmedNoun}
      </GuestsSection>
      <ArrowSection gridArea="arrow">
        <i className="af-angle-right" />
      </ArrowSection>
    </Row>
  );
};

export const LoadingRow = () => (
  <Row>
    <DateSection gridArea="date">
      <Text>
        <ContentLoader height={32} width={30} />
      </Text>
      <Text>
        <ContentLoader height={16} width={50} />
      </Text>
    </DateSection>
    <PictureSection gridArea="picture">
      <ContentLoader height="100%" width="100%" />
    </PictureSection>
    <NameSection gridArea="name">
      <Text>
        <ContentLoader height={18} width={160} />
      </Text>
      <br />
      <Text>
        <ContentLoader height={14} width={120} />
      </Text>
    </NameSection>
  </Row>
);

export default SlotRow;
